import { buttonBase } from "./styles/layoutStyles";

// Couleurs de la charte SUIVI QUALITÉ, utilisées par les deux écrans de contrôle.
export const CHARTER_COLORS = {
    page: "#F4F1EA",
    surface: "#ffffff",
    surfaceMuted: "#F4F1EA",
    ink: "#122A26",
    muted: "#5A6D68",
    border: "#dfe6e2",
    borderStrong: "#cfd8d4",
    primary: "#0C3B3C",
    primaryDark: "#0C3B3C",
    primarySoft: "#e8f1ef",
    accent: "#17B978",
    success: "#17B978",
    successSoft: "#dff5ec",
    warning: "#C8A44D",
    warningSoft: "#fff8e3",
    danger: "#C1422E",
    dangerSoft: "#fdebea",
};

export function validationStatusColors(value) {
    return value === "LANCE"
        ? { background: "#dcfce7", borderColor: "#86efac", color: "#166534" }
        : { background: "#fee2e2", borderColor: "#fecaca", color: "#991b1b" };
}

function charterLaunchStatusSelectStyle(inputStyle) {
    return (value, disabled = false) => ({
        ...inputStyle,
        ...validationStatusColors(value),
        width: "100%",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.7 : 1,
        fontWeight: 900,
    });
}

export const CHARTER_THEME = {
    inputStyle: {
        border: `1px solid ${CHARTER_COLORS.borderStrong}`,
        borderRadius: "7px",
        padding: "7px 9px",
        fontSize: "13px",
        background: CHARTER_COLORS.surface,
        color: CHARTER_COLORS.ink,
        boxSizing: "border-box",
    },
    actionButtonStyle: {
        ...buttonBase,
        height: "40px",
        padding: "0 16px",
        background: "white",
        borderColor: CHARTER_COLORS.border,
        color: CHARTER_COLORS.ink,
        fontWeight: 900,
    },
};

CHARTER_THEME.launchStatusSelectStyle = charterLaunchStatusSelectStyle(CHARTER_THEME.inputStyle);

// Couleurs des pastilles numérotées des points de contrôle, en boucle.
export const CONTROL_POINT_COLORS = [CHARTER_COLORS.accent, CHARTER_COLORS.primary, CHARTER_COLORS.warning, CHARTER_COLORS.muted];

export const PATIENT_STATUS_PALETTE = {
    inactiveBackground: CHARTER_COLORS.dangerSoft,
    blockingBackground: CHARTER_COLORS.warningSoft,
    validatedBackground: CHARTER_COLORS.successSoft,
    activeBackground: CHARTER_COLORS.primarySoft,
    activeIndicator: CHARTER_COLORS.primary,
    inactiveIndicator: CHARTER_COLORS.danger,
    blockingIndicator: CHARTER_COLORS.warning,
    validatedIndicator: CHARTER_COLORS.accent,
};
